import { jsx } from "react/jsx-runtime";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { validateTidalLicense } from "../../base/index.js";
function ExpandMore(props) {
  return /* @__PURE__ */ jsx(
    ExpandMoreIcon,
    {
      "data-testid": "ExpandMore",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ExpandMore",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ExpandMore.tidalIconMeta = {
  categories: "arrows",
  name: "ExpandMore"
};
validateTidalLicense();
export {
  ExpandMore
};
//# sourceMappingURL=ExpandMore.js.map
